// Read more and Read less functionality
const readMoreButtons = document.querySelectorAll('.truncated .read-more-collection')
const readLessButtons = document.querySelectorAll('.fullDescription .read-more-collection')

const toggleDescription = (btn, otherBtn, show, hide) => {
  btn.closest(hide).style.display = "none";
  otherBtn.closest(show).style.display = "block";
};

if(readMoreButtons){
  readMoreButtons.forEach((btn, i) => {
    btn.addEventListener('click', () => toggleDescription(btn, readLessButtons[i], '.fullDescription', '.truncated'));
  });
}
if(readLessButtons){
  readLessButtons.forEach((btn, i) => {
    btn.addEventListener('click', () => toggleDescription(btn, readMoreButtons[i],  '.truncated', '.fullDescription'));
  });
}